<agr-page-toolbar
  [isEmpty]="(barns$ | async)?.length === 0"
  [emptyTitle]="'settings.no-barns.title' | translate"
  [emptyDescription]="'settings.no-barns.description' | translate"
  emptyImage="assets/images/arrival.jpg"
  [hasPrimaryAction]="true"
  primaryActionIcon="add"
  [primaryActionText]="'settings.barn-item.add' | translate"
  (primaryAction)="openBarnDetail()"
  data-test="barn-overview"
>
  <ng-container *ngIf="(isLoading$ | async) === false && barns$ | async as barns">
    <mat-nav-list
      *ngIf="barns.length"
      class="barn-overview__list"
      [@listAnimationStagger]="barns.length"
    >
      <a
        mat-list-item
        class="barn-item"
        data-test="barn-overview__item"
        *ngFor="let barn of barns"
        (click)="openBarnDetail(barn)"
      >
        <div matListItemTitle>{{ barn.name }}</div>
        <div matListItemLine class="text--gray">{{ barn.surfaceArea | agrNumber }} m2</div>
        <button matListItemMeta mat-icon-button (click)="delete($event, barn)">
          <mat-icon>delete</mat-icon>
        </button>
      </a>
      <mat-divider *ngIf="barns.length > 0"></mat-divider>
    </mat-nav-list>
  </ng-container>
</agr-page-toolbar>
